import { MachineObject } from '../../interfaces/Machines.interfaces';
import { GetQueryId } from '../../interfaces/Ordel.Interface';
import { api } from '../slices/api';

// Define a service using a base URL and expected endpoints
export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getMachines: builder.query<
			MachineObject[],
			{ machine_model__type?: string }
		>({
			query: (params) => {
				const queryParams = new URLSearchParams();
				Object.entries(params).forEach(([key, value]) => {
					if (value !== undefined) {
						queryParams.append(key, value.toString());
					}
				});
				return `machines/machines/?${queryParams.toString()}`;
			},
		}),
		getMachineById: builder.query<MachineObject, GetQueryId>({
			query: ({ id }) => `machines/machines/${id}`,
		}),
		getTrunnions: builder.query<MachineObject[], void>({
			query: () => 'machines/trunnions',
		}),
		getMachineCycleTimes: builder.query<MachineObject[], void>({
			query: () => 'machines/cycle-time/',
		}),
		getMachineStatuses: builder.query<MachineObject[], void>({
			query: () => 'machines/machines/statuses',
		}),
	}),
	overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetMachinesQuery,
	useLazyGetMachinesQuery,
	useGetMachineByIdQuery,
	useGetTrunnionsQuery,
	useGetMachineCycleTimesQuery,
	useGetMachineStatusesQuery,
} = extendedApiSlice;
